import { createApp } from "vue";
import { createPinia } from "pinia";
import * as Sentry from "@sentry/vue";
import $ from "jquery";
import router from "@/router";
import App from "@/App.vue";

// Expose jQuery globally for bootstrap-table
window.jQuery = $;
window.$ = $;

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import "bootstrap-icons/font/bootstrap-icons.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "slim-select/styles";
import "bootstrap-table/dist/bootstrap-table.min.css";
import "@/assets/css/style.css";
import "@/assets/css/main.css";

const app = createApp(App);

// Pinia (state management)
app.use(createPinia());

// Sentry / GlitchTip (error tracking)
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    app,
    dsn: sentryDsn,
    integrations: [Sentry.browserTracingIntegration({ router })],
    tracesSampleRate: 0.01,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_RELEASE,
  });
}

// Vue Router
app.use(router);

app.mount("#app");
